module.exports = __webpack_public_path__ + "img/7.ba13ab7b.jpg";